module.exports = __webpack_public_path__ + "media/application/images/demo/main4-7e064ce2bc23e217c86629c01617bafb.jpg";